"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4939],{

/***/ 4580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FormBookNowTop; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2175);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7294);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7258);
/* harmony import */ var _utils_functions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9735);
/* harmony import */ var _utils_hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1127);
/* harmony import */ var _LoadingSpinner__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8506);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}










var UnsafeFlex = _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb;
var UnsafeCenter = _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Center */ .M5Y;
var UnsafeFormLabel = _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .FormLabel */ .lXp;
var UnsafeButton = _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zxk;
var UnsafeSelect = _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Select */ .PhF;
var UnsafeInput = _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Input */ .IIB;
var UnsafeText = _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT;
function FormBookNowTop(param) {
    var hotelCode = param.hotelCode, colorPrimary = param.colorPrimary;
    var handleClick = function handleClick() {
        var ref;
        var _values = formik.values, adults = _values.adults, arrival = _values.arrival, child = _values.child, departure = _values.departure, hotel = _values.hotel, voucher = _values.voucher;
        var bookingHotelCode = (hotel === null || hotel === void 0 ? void 0 : hotel.hotel_code) || (hotels === null || hotels === void 0 ? void 0 : (ref = hotels[0]) === null || ref === void 0 ? void 0 : ref.hotel_code);
        var bookingConfig = (0,_utils_functions__WEBPACK_IMPORTED_MODULE_7__/* .getBookingEngineHotelConfig */ .Np)(bookingHotelCode);
        if (!bookingConfig) return;
        (0,_utils_functions__WEBPACK_IMPORTED_MODULE_7__/* .submitBookingEngineForm */ .Sw)({
            action: bookingConfig.action,
            fields: {
                language: (0,_utils_functions__WEBPACK_IMPORTED_MODULE_7__/* .getBookingEngineLocale */ .cG)(router.locale),
                arrivalDate: (0,lodash__WEBPACK_IMPORTED_MODULE_3__.isEmpty)(arrival) ? "" : arrival,
                nights: (0,_utils_functions__WEBPACK_IMPORTED_MODULE_7__/* .getBookingEngineNights */ .cl)(arrival, departure),
                guestCountSelector: "ReadOnly",
                crossSell: "false",
                selectedAdultCount: adults,
                selectedChildCount: child,
                rate: voucher
            }
        });
    };
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var locale = (0,_utils_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useLocale */ .bU)();
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(""), minDate = ref3[0], setMinDate = ref3[1];
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        setMinDate(new Date().toISOString().split("T")[0]);
    }, []);
    var ref1 = (0,_utils_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useGetListHotel */ .e7)(), hotels = ref1.hotels, isLoading = ref1.isLoading;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)("-1"), selectedHotel = ref2[0], setSelectedHotel = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        if (hotels && hotelCode) {
            var temp = (0,lodash__WEBPACK_IMPORTED_MODULE_3__.findKey)(hotels, function(o) {
                return o.hotel_code == hotelCode;
            });
            if (temp !== undefined) {
                setSelectedHotel((0,lodash__WEBPACK_IMPORTED_MODULE_3__.toString)(temp));
            }
        }
    }, [
        hotels,
        hotelCode
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        if (hotels && selectedHotel !== -1 && selectedHotel !== "-1" && hotels[selectedHotel]) {
            formik.setValues(_objectSpread({}, formik.values, {
                hotel: hotels[selectedHotel]
            }));
        }
    }, [
        selectedHotel,
        hotels
    ]);
    var formik = (0,formik__WEBPACK_IMPORTED_MODULE_2__/* .useFormik */ .TA)({
        enableReinitialize: true,
        initialValues: {
            arrival: "",
            departure: "",
            hotel: hotels ? hotels[0] : {},
            rooms: 1,
            adults: 2,
            child: 0,
            voucher: ""
        },
        validationSchema: yup__WEBPACK_IMPORTED_MODULE_6__/* .object */ .Ry({
            arrival: yup__WEBPACK_IMPORTED_MODULE_6__/* .string */ .Z_().required(locale == "id" ? "Harus diisi" : "Required"),
            departure: yup__WEBPACK_IMPORTED_MODULE_6__/* .string */ .Z_().required(locale == "id" ? "Harus diisi" : "Required"),
            hotel: yup__WEBPACK_IMPORTED_MODULE_6__/* .object */ .Ry(),
            rooms: yup__WEBPACK_IMPORTED_MODULE_6__/* .number */ .Rx(),
            adults: yup__WEBPACK_IMPORTED_MODULE_6__/* .number */ .Rx(),
            child: yup__WEBPACK_IMPORTED_MODULE_6__/* .number */ .Rx(),
            voucher: yup__WEBPACK_IMPORTED_MODULE_6__/* .string */ .Z_()
        }),
        onSubmit: function() {}
    });
    // Ambil nilai persistensi dari localStorage saat client-side mount
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        var savedArrival = (0,_utils_functions__WEBPACK_IMPORTED_MODULE_7__/* .getLocalStorage */ .$o)("booking_arrival", "");
        var savedDeparture = (0,_utils_functions__WEBPACK_IMPORTED_MODULE_7__/* .getLocalStorage */ .$o)("booking_departure", "");
        if (savedArrival || savedDeparture) {
            formik.setValues(_objectSpread({}, formik.values, {
                arrival: savedArrival,
                departure: savedDeparture
            }));
        }
    }, []);
    // Efek untuk menyinkronkan data tanggal ke localStorage saat ada perubahan
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        if (formik.values.arrival) {
            (0,_utils_functions__WEBPACK_IMPORTED_MODULE_7__/* .setLocalStorage */ .qQ)("booking_arrival", formik.values.arrival);
        }
    }, [
        formik.values.arrival
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        if (formik.values.departure) {
            (0,_utils_functions__WEBPACK_IMPORTED_MODULE_7__/* .setLocalStorage */ .qQ)("booking_departure", formik.values.departure);
        }
    }, [
        formik.values.departure
    ]);
    if (isLoading || !hotels || !selectedHotel) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UnsafeFlex, {
        bg: colorPrimary,
        color: "white",
        py: 6,
        px: 5,
        borderRadius: 10,
        flexDir: "column",
        gap: 4,
        w: "100%",
        fontSize: "sm",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UnsafeCenter, {
            h: 10,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LoadingSpinner__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
        })
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(UnsafeFlex, {
        bg: colorPrimary,
        color: "white",
        py: 6,
        px: 5,
        borderRadius: 10,
        flexDir: "column",
        gap: 4,
        w: "100%",
        maxW: 600,
        fontSize: "sm",
        opacity: 0.9,
        border: "1px solid var(--chakra-colors-whiteAlpha-600)",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(UnsafeFlex, {
                gap: [
                    0,
                    null,
                    null,
                    8
                ],
                w: "full",
                flexWrap: [
                    "wrap",
                    null,
                    null,
                    "nowrap"
                ],
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(UnsafeFlex, {
                        flexDir: "column",
                        w: [
                            "full",
                            null,
                            null,
                            "50%"
                        ],
                        mb: [
                            3,
                            null,
                            null,
                            0
                        ],
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UnsafeFormLabel, {
                                fontSize: "xs",
                                textTransform: "uppercase",
                                fontWeight: 500,
                                children: locale == "id" ? "Kedatangan" : "Arrival"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UnsafeInput, {
                                        textTransform: "uppercase",
                                        fontSize: "sm",
                                        color: "white",
                                        colorScheme: "white",
                                        type: "date",
                                        lang: "fr-CA",
                                        borderRadius: 0,
                                        borderColor: "whiteAlpha.600",
                                        _placeholder: {
                                            color: "white",
                                            opacity: 1
                                        },
                                        style: {
                                            colorScheme: "dark"
                                        },
                                        min: minDate,
                                        onChange: function(e) {
                                            var nextDate = (0,_utils_functions__WEBPACK_IMPORTED_MODULE_7__/* .increaseDate */ .Hc)(e.target.value);
                                            formik.setValues(_objectSpread({}, formik.values, {
                                                arrival: e.target.value,
                                                departure: nextDate
                                            }));
                                            (0,_utils_functions__WEBPACK_IMPORTED_MODULE_7__/* .setLocalStorage */ .qQ)("booking_arrival", e.target.value);
                                            (0,_utils_functions__WEBPACK_IMPORTED_MODULE_7__/* .setLocalStorage */ .qQ)("booking_departure", nextDate);
                                        },
                                        id: "arrival",
                                        name: "arrival",
                                        value: formik.values.arrival
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UnsafeText, {
                                        fontSize: "xs",
                                        color: "red.500",
                                        mt: 1,
                                        children: formik.errors.arrival
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(UnsafeFlex, {
                        flexDir: "column",
                        w: [
                            "full",
                            null,
                            null,
                            "50%"
                        ],
                        mb: [
                            3,
                            null,
                            null,
                            0
                        ],
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UnsafeFormLabel, {
                                fontSize: "xs",
                                textTransform: "uppercase",
                                fontWeight: 500,
                                children: locale == "id" ? "Kepergian" : "Departure"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UnsafeInput, {
                                        textTransform: "uppercase",
                                        fontSize: "sm",
                                        disabled: !formik.values.arrival,
                                        min: new Date(new Date().setDate(new Date(formik.values.arrival == "" ? new Date() : formik.values.arrival).getDate() + 1)).toISOString().split("T")[0],
                                        color: "white",
                                        colorScheme: "white",
                                        type: "date",
                                        borderRadius: 0,
                                        borderColor: "whiteAlpha.600",
                                        _placeholder: {
                                            color: "white",
                                            opacity: 1
                                        },
                                        style: {
                                            colorScheme: "dark"
                                        },
                                        onChange: function(e) {
                                            formik.setValues(_objectSpread({}, formik.values, {
                                                departure: e.target.value
                                            }));
                                        },
                                        id: "departure",
                                        name: "departure",
                                        value: formik.values.departure
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UnsafeText, {
                                        fontSize: "xs",
                                        color: "red.500",
                                        mt: 1,
                                        children: formik.errors.departure
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(UnsafeFlex, {
                flexDir: "column",
                w: "100%",
                mb: [
                    3,
                    null,
                    null,
                    0
                ],
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UnsafeFormLabel, {
                        fontSize: "xs",
                        textTransform: "uppercase",
                        fontWeight: 500,
                        children: locale == "id" ? "Pilih Hotel" : "Choose Hotel"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UnsafeSelect, {
                            fontSize: "sm",
                            color: "white",
                            colorScheme: "white",
                            borderRadius: 0,
                            borderColor: "whiteAlpha.600",
                            _focus: {},
                            // defaultValue={selectedHotel}
                            value: selectedHotel,
                            onChange: function(e) {
                                var val = e.target.value;
                                setSelectedHotel(val);
                                if (hotels && hotels[val]) {
                                    formik.setValues(_objectSpread({}, formik.values, {
                                        hotel: hotels[val]
                                    }));
                                }
                            },
                            children: hotels === null || hotels === void 0 ? void 0 : hotels.map(function(hotel, i) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                    value: i,
                                    style: {
                                        color: "black"
                                    },
                                    children: hotel.name
                                }, hotel.name);
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(UnsafeFlex, {
                gap: 8,
                w: "full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(UnsafeFlex, {
                        flexDir: "column",
                        w: "33%",
                        mb: [
                            3,
                            null,
                            null,
                            0
                        ],
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UnsafeFormLabel, {
                                fontSize: "xs",
                                textTransform: "uppercase",
                                fontWeight: 500,
                                children: locale == "id" ? "Kamar" : "Rooms"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UnsafeInput, {
                                        fontSize: "sm",
                                        color: "white",
                                        colorScheme: "white",
                                        type: "number",
                                        borderRadius: 0,
                                        borderColor: "whiteAlpha.600",
                                        _placeholder: {
                                            color: "white",
                                            opacity: 1
                                        },
                                        placeholder: "1",
                                        onChange: function(e) {
                                            formik.setValues(_objectSpread({}, formik.values, {
                                                rooms: (0,lodash__WEBPACK_IMPORTED_MODULE_3__.toNumber)(e.target.value)
                                            }));
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UnsafeText, {
                                        fontSize: "xs",
                                        color: "red.500",
                                        mt: 1,
                                        children: formik.errors.rooms
                                    })
                                ]
                            })
                        ]
                    }),
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(UnsafeFlex, {
                        flexDir: "column",
                        w: "33%",
                        mb: [
                            3,
                            null,
                            null,
                            0
                        ],
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UnsafeFormLabel, {
                                fontSize: "xs",
                                textTransform: "uppercase",
                                fontWeight: 500,
                                children: locale == "id" ? "Dewasa" : "Adults"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UnsafeInput, {
                                        fontSize: "sm",
                                        color: "white",
                                        colorScheme: "white",
                                        type: "number",
                                        borderRadius: 0,
                                        borderColor: "whiteAlpha.600",
                                        _placeholder: {
                                            color: "white",
                                            opacity: 1
                                        },
                                        placeholder: "2",
                                        onChange: function(e) {
                                            formik.setValues(_objectSpread({}, formik.values, {
                                                adults: (0,lodash__WEBPACK_IMPORTED_MODULE_3__.toNumber)(e.target.value)
                                            }));
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UnsafeText, {
                                        fontSize: "xs",
                                        color: "red.500",
                                        mt: 1,
                                        children: formik.errors.adults
                                    })
                                ]
                            })
                        ]
                    }),
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(UnsafeFlex, {
                        flexDir: "column",
                        w: "33%",
                        mb: [
                            3,
                            null,
                            null,
                            0
                        ],
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UnsafeFormLabel, {
                                fontSize: "xs",
                                textTransform: "uppercase",
                                fontWeight: 500,
                                children: locale == "id" ? "Anak" : "Child"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UnsafeInput, {
                                        fontSize: "sm",
                                        color: "white",
                                        colorScheme: "white",
                                        type: "number",
                                        borderRadius: 0,
                                        borderColor: "whiteAlpha.600",
                                        _placeholder: {
                                            color: "white",
                                            opacity: 1
                                        },
                                        placeholder: "0",
                                        onChange: function(e) {
                                            formik.setValues(_objectSpread({}, formik.values, {
                                                child: (0,lodash__WEBPACK_IMPORTED_MODULE_3__.toNumber)(e.target.value)
                                            }));
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UnsafeText, {
                                        fontSize: "xs",
                                        color: "red.500",
                                        mt: 1,
                                        children: formik.errors.child
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(UnsafeFlex, {
                flexDir: "column",
                w: "100%",
                mb: [
                    3,
                    null,
                    null,
                    0
                ],
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UnsafeFormLabel, {
                        fontSize: "xs",
                        textTransform: "uppercase",
                        fontWeight: 500,
                        children: locale == "id" ? "Kode Promo" : "Promo Code"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UnsafeInput, {
                                fontSize: "sm",
                                color: "white",
                                colorScheme: "white",
                                type: "text",
                                borderRadius: 0,
                                borderColor: "whiteAlpha.600",
                                placeholder: locale == "id" ? "Masukkan Kode" : "Insert Code",
                                _placeholder: {
                                    color: "white",
                                    opacity: 1
                                },
                                onChange: function(e) {
                                    formik.setValues(_objectSpread({}, formik.values, {
                                        voucher: e.target.value
                                    }));
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UnsafeText, {
                                fontSize: "xs",
                                color: "red.500",
                                mt: 1,
                                children: formik.errors.voucher
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UnsafeCenter, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UnsafeButton, {
                    variant: "solid",
                    bg: "white",
                    color: "black",
                    onClick: handleClick,
                    disabled: !formik.isValid || (0,lodash__WEBPACK_IMPORTED_MODULE_3__.isEmpty)(formik.values.arrival),
                    children: locale == "id" ? "Pesan" : "Book Now"
                })
            })
        ]
    });
};


/***/ }),

/***/ 6269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LinkTo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




function LinkTo(props) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var variant = props.variant, _to = props.to, to = _to === void 0 ? "#" : _to, _active = props.active, active = _active === void 0 ? false : _active, _activeColor = props.activeColor, activeColor = _activeColor === void 0 ? "white" : _activeColor, children = props.children, _disabled = props.disabled, disabled = _disabled === void 0 ? false : _disabled, rest = _objectWithoutProperties(props, [
        "variant",
        "to",
        "active",
        "activeColor",
        "children",
        "disabled"
    ]);
    var styles = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .useStyleConfig */ .mqc)("LinkTo", {
        variant: variant
    });
    var _obj, _obj1;
    // Pass the computed styles into the `__css` prop
    // const {  } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: to,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, _objectSpread({
            _disabled: disabled,
            __css: styles
        }, rest, {
            position: "relative",
            _after: active ? (_obj = {
                background: "none repeat scroll 0 0 transparent",
                bottom: -1,
                left: 0,
                content: '""',
                display: "block",
                height: "1px",
                position: "absolute"
            }, _defineProperty(_obj, "background", activeColor), _defineProperty(_obj, "transition", "all 0.3s ease 0s, left 0.3s ease 0s"), _defineProperty(_obj, "width", "100%"), _obj) : (_obj1 = {
                background: "none repeat scroll 0 0 transparent",
                bottom: -1,
                content: '""',
                display: "block",
                height: "1px",
                left: "50%",
                position: "absolute"
            }, _defineProperty(_obj1, "background", activeColor), _defineProperty(_obj1, "transition", "all 0.3s ease 0s, left 0.3s ease 0s"), _defineProperty(_obj1, "width", 0), _obj1),
            _focus: {},
            _hover: !active && {
                _after: {
                    width: "100%",
                    left: 0
                }
            },
            children: children
        }))
    });
};


/***/ }),

/***/ 8506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LoadingSpinner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);


function LoadingSpinner() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Center */ .M5Y, {
        h: "50vh",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Spinner */ .$jN, {
            size: "xl"
        })
    });
};


/***/ }),

/***/ 9536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Helmet; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./public/parador.png
/* harmony default export */ var parador = ({"src":"/_next/static/media/parador.77509965.png","height":159,"width":318,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAACVBMVEUiFkU+NF0vJVEXuz4rAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGklEQVQImWNggAMmJkZGJiYGBiZGMGCCywAAAYwAFZSVv9oAAAAASUVORK5CYII="});
// EXTERNAL MODULE: ./src/utils/functions.js
var functions = __webpack_require__(9735);
;// CONCATENATED MODULE: ./src/containers/Helmet.tsx





function Helmet(param) {
    var title = param.title, _description = param.description, description = _description === void 0 ? "" : _description, children = param.children, _image = param.image, image = _image === void 0 ? parador.src : _image;
    var asPath = (0,router.useRouter)().asPath;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: (0,functions/* capEachWord */.x8)(title)
            }),
            description && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "keywords",
                content: ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "author",
                content: "Parador"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "google-site-verification",
                content: ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "og:title",
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "og:description",
                property: "og:description",
                content: description !== null && description !== void 0 ? description : ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:site_name",
                content: "Parador Website"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:url",
                content: "https://parador-hotels.com/" + asPath.substring(1)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                itemProp: "image",
                content: image
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:title",
                content: (0,functions/* capEachWord */.x8)(title)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:site",
                content: "paradorhotels"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:description",
                content: description !== null && description !== void 0 ? description : ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:image",
                content: image
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                href: "/favicon.ico"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                href: "/favicon.ico"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                type: "image/x-icon",
                href: "/favicon.ico?v=3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: ""
            }),
            !functions/* isDev */.r8 && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                httpEquiv: "Content-Security-Policy",
                content: "upgrade-insecure-requests"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1.0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
            }),
            children
        ]
    });
};


/***/ }),

/***/ 4850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ HeaderV3; }
});

// UNUSED EXPORTS: NavContext

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/chakra-ui-icons.esm.js + 5 modules
var chakra_ui_icons_esm = __webpack_require__(9277);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/index.mjs + 808 modules
var dist = __webpack_require__(8029);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var index_esm = __webpack_require__(9583);
// EXTERNAL MODULE: ./node_modules/react-icons/io5/index.esm.js
var io5_index_esm = __webpack_require__(155);
// EXTERNAL MODULE: ./src/components/FormBookNowTop.tsx
var FormBookNowTop = __webpack_require__(4580);
;// CONCATENATED MODULE: ./src/assets/svg/en.svg
/* harmony default export */ var en = ({"src":"/_next/static/media/en.53b0f7d9.svg","height":480,"width":640});
;// CONCATENATED MODULE: ./src/assets/svg/id.svg
/* harmony default export */ var id = ({"src":"/_next/static/media/id.e65d9b99.svg","height":480,"width":640});
;// CONCATENATED MODULE: ./src/components/Input/InputSelect.tsx







function InputSelect(param) {
    var icon = param.icon, placeHolder = param.placeHolder, items = param.items;
    var ref = (0,next_router.useRouter)(), pathname = ref.pathname, asPath = ref.asPath, query = ref.query, push = ref.push, locale = ref.locale;
    var modalRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(false), isOptionsOpen = ref1[0], setIsOptionsOpen = ref1[1];
    var ref2 = (0,react.useState)(0), selectedOption = ref2[0], setSelectedOption = ref2[1];
    (0,dist/* useOutsideClick */.O3d)({
        ref: modalRef,
        handler: function() {
            return setIsOptionsOpen(false);
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Box */.xuv, {
        ref: modalRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                alignItems: "center",
                gap: 1,
                justifyContent: "space-evenly",
                onClick: function() {
                    setIsOptionsOpen(!isOptionsOpen);
                },
                cursor: "pointer",
                children: [
                    icon,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                        w: "100%",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                            children: placeHolder
                        })
                    })
                ]
            }),
            isOptionsOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Box */.xuv, {
                zIndex: 1,
                position: "absolute",
                top: 14,
                right: 10,
                bg: "white",
                color: "blackAlpha.800",
                fontSize: "md",
                minW: 220,
                px: 6,
                py: 4,
                borderBottomRadius: "10px",
                display: "flex",
                flexDir: "column",
                gap: 2,
                className: "header-box-shadows",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* AbsoluteCenter */.umj, {
                        top: -1.5,
                        style: {
                            width: 0,
                            height: 0,
                            borderLeft: "12px solid transparent",
                            borderRight: "12px solid transparent",
                            borderBottom: "12px solid white"
                        }
                    }),
                    items.length > 0 && items.map(function(item, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                                    align: "center",
                                    gap: 1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                            position: "relative",
                                            h: 4,
                                            w: 6,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: item.value == "id" ? id : en,
                                                alt: "",
                                                layout: "fill",
                                                objectFit: "contain",
                                                priority: true,
                                                unoptimized: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                            onClick: function() {
                                                push({
                                                    pathname: pathname,
                                                    query: query
                                                }, asPath, {
                                                    locale: item.value
                                                });
                                                setIsOptionsOpen(false);
                                            },
                                            cursor: "pointer",
                                            _hover: {
                                                color: "black"
                                            },
                                            children: item.name
                                        })
                                    ]
                                }),
                                i != items.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Divider */.izJ, {
                                        orientation: "horizontal"
                                    })
                                })
                            ]
                        }, item.value);
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Input/LoginSelect.tsx
/* provided dependency */ var process = __webpack_require__(3454);





function LoginSelect(param) {
    var icon = param.icon, placeHolder = param.placeHolder, items = param.items;
    var ref = (0,next_router.useRouter)(), pathname = ref.pathname, asPath = ref.asPath, query = ref.query, push = ref.push, locale = ref.locale;
    var modalRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(false), isOptionsOpen = ref1[0], setIsOptionsOpen = ref1[1];
    var ref2 = (0,react.useState)(0), hoverOption = ref2[0], setHoverOption = ref2[1];
    (0,dist/* useOutsideClick */.O3d)({
        ref: modalRef,
        handler: function() {
            return setIsOptionsOpen(false);
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Box */.xuv, {
        ref: modalRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                alignItems: "center",
                gap: 1,
                justifyContent: "space-evenly",
                onClick: function() {
                    setIsOptionsOpen(!isOptionsOpen);
                },
                cursor: "pointer",
                children: [
                    icon,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                        w: "100%",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                            children: placeHolder
                        })
                    })
                ]
            }),
            isOptionsOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Box */.xuv, {
                zIndex: 1,
                position: "absolute",
                // top={`160px`}
                top: 14,
                right: "7.5rem",
                bg: "white",
                color: "blackAlpha.800",
                fontSize: "md",
                minW: 220,
                px: 6,
                py: 4,
                borderBottomRadius: "10px",
                display: "flex",
                flexDir: "column",
                gap: 2,
                className: "header-box-shadows",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* AbsoluteCenter */.umj, {
                        top: -1.5,
                        style: {
                            width: 0,
                            height: 0,
                            borderLeft: "12px solid transparent",
                            borderRight: "12px solid transparent",
                            borderBottom: "12px solid white"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Box */.xuv, {
                        onClick: function() {
                            hoverOption != 1 ? setHoverOption(1) : setHoverOption(0);
                        },
                        cursor: "pointer",
                        _hover: {
                            color: "black"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                                align: "center",
                                justify: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                        children: locale == "id" ? "Individu" : "Individual"
                                    }),
                                    hoverOption == 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoChevronDown */.CgR, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoChevronForward */.mzm, {})
                                ]
                            }),
                            hoverOption == 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                                letterSpacing: "wider",
                                mt: 2,
                                ml: 3,
                                flexDir: "column",
                                justify: "space-between",
                                gap: 1,
                                color: "blackAlpha.800",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                        cursor: "pointer",
                                        _hover: {
                                            color: "black"
                                        },
                                        onClick: function() {
                                            window.open("".concat(process.env.NEXT_PUBLIC_URL_HOTEL_ENGINE, "/signin?chain=28800&level=chain"), "_blank");
                                            setHoverOption(0);
                                            setIsOptionsOpen(false);
                                        },
                                        children: locale == "id" ? "Masuk" : "Login"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Divider */.izJ, {
                                            orientation: "horizontal"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                        cursor: "pointer",
                                        onClick: function() {
                                            window.open("".concat(process.env.NEXT_PUBLIC_URL_HOTEL_ENGINE, "/sign-up?chain=28800&level=chain"), "_blank");
                                            setHoverOption(0);
                                            setIsOptionsOpen(false);
                                        },
                                        _hover: {
                                            color: "black"
                                        },
                                        children: locale == "id" ? "Daftar" : "Register"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Divider */.izJ, {
                            orientation: "horizontal"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Box */.xuv, {
                        onClick: function() {
                            hoverOption != 2 ? setHoverOption(2) : setHoverOption(0);
                        },
                        cursor: "pointer",
                        _hover: {
                            color: "black"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                                align: "center",
                                justify: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                        children: locale == "id" ? "Perusahaan" : "Company"
                                    }),
                                    hoverOption == 2 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoChevronDown */.CgR, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoChevronForward */.mzm, {})
                                ]
                            }),
                            hoverOption == 2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                                // textTransform="uppercase"
                                letterSpacing: "wider",
                                mt: 2,
                                ml: 3,
                                flexDir: "column",
                                justify: "space-between",
                                gap: 1,
                                color: "blackAlpha.800",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                        _hover: {
                                            color: "black"
                                        },
                                        cursor: "pointer",
                                        onClick: function() {
                                            window.open("https://cbt.synxis.com/?chainId=28800", "_blank");
                                            setHoverOption(0);
                                            setIsOptionsOpen(false);
                                        },
                                        children: locale == "id" ? "Masuk" : "Login"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Divider */.izJ, {
                                            orientation: "horizontal"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                        cursor: "pointer",
                                        onClick: function() {
                                            setHoverOption(0);
                                            setIsOptionsOpen(false);
                                            push("/register");
                                        },
                                        _hover: {
                                            color: "black"
                                        },
                                        children: locale == "id" ? "Daftar" : "Register"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/LinkTo.jsx
var LinkTo = __webpack_require__(6269);
// EXTERNAL MODULE: ./src/utils/functions.js
var functions = __webpack_require__(9735);
// EXTERNAL MODULE: ./src/utils/hooks.js + 1 modules
var hooks = __webpack_require__(1127);
// EXTERNAL MODULE: ./src/utils/mediaQuery.js
var mediaQuery = __webpack_require__(9741);
;// CONCATENATED MODULE: ./src/layout/HeaderV3.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}















var NavContext = /*#__PURE__*/ (/* unused pure expression or super */ null && (createContext(null)));
var UnsafeFlex = dist/* Flex */.kCb;
var UnsafeText = dist/* Text */.xvT;
var UnsafeInputGroup = dist/* InputGroup */.BZy;
var UnsafeSelect = dist/* Select */.PhF;
var UnsafeHeading = dist/* Heading */.X6q;
var UnsafeSpinner = dist/* Spinner */.$jN;
var UnsafeAccordion = dist/* Accordion */.UQy;
var UnsafeAccordionItem = dist/* AccordionItem */.Qdk;
var UnsafeAccordionButton = dist/* AccordionButton */.KFZ;
var UnsafeAccordionPanel = dist/* AccordionPanel */.Hk3;
var UnsafeAccordionIcon = dist/* AccordionIcon */.XEm;
var UnsafeButton = dist/* Button */.zxk;
var UnsafeInput = dist/* Input */.IIB;
var UnsafeDivider = dist/* Divider */.izJ;
function HeaderV3(param1) {
    var headerItem = param1.headerItem, isHomepage = param1.isHomepage, getHeight = param1.getHeight, hotelBrands = param1.hotelBrands, _isDining = param1.isDining, isDining = _isDining === void 0 ? false : _isDining;
    var handleBook = function handleBook() {
        setShowBookNowTop(!showBookNowTop);
    };
    var handleActiveColor = function handleActiveColor() {
        if (isHomepage && !offsetHeader) return "white";
        if (is_parador && !isHomepage) return "black";
        return color_primary.toString();
    };
    var ref = (0,next_router.useRouter)(), route = ref.route, asPath = ref.asPath, push = ref.push, locales = ref.locales, locale = ref.locale, pathname = ref.pathname, query = ref.query, isReady = ref.isReady;
    var id1 = headerItem.id, name1 = headerItem.name, color_primary = headerItem.color_primary, _color_secondary = headerItem.color_secondary, color_secondary = _color_secondary === void 0 ? "white" : _color_secondary, location = headerItem.location, location_url = headerItem.location_url, phone = headerItem.phone, logo_dark = headerItem.logo_dark, logo_light = headerItem.logo_light, slug1 = headerItem.slug, _hotel_code = headerItem.hotel_code, hotel_code = _hotel_code === void 0 ? 36461 : _hotel_code, is_parador = headerItem.is_parador, has_dining = headerItem.has_dining, has_meeting_events = headerItem.has_meeting_events, has_wedding = headerItem.has_wedding;
    // const { isLarge, is2XLarge } = useLargeQuery();
    var ref1 = _slicedToArray((0,dist/* useMediaQuery */.ach)("(min-width:  1160px)", {
        ssr: true,
        fallback: false
    }), 1), is2XLarge = ref1[0];
    var container = (0,react.useRef)(null);
    var headerContainer = (0,react.useRef)(null);
    var ref2 = (0,react.useState)(false), offsetHeader = ref2[0], setOffsetHeader = ref2[1];
    var ref3 = (0,react.useState)(false), offsetBookNow = ref3[0], setOffsetBookNow = ref3[1];
    var ref4 = (0,react.useState)(false), isNavPop1 = ref4[0], setIsNavPop = ref4[1];
    var ref5 = (0,react.useState)(asPath), navPosition1 = ref5[0], setNavPosition = ref5[1];
    var ref6 = (0,react.useState)(false), isMobilePop = ref6[0], setIsMobilePop = ref6[1];
    var ref7 = (0,react.useState)(false), showBookNowTop = ref7[0], setShowBookNowTop = ref7[1];
    var ref8 = (0,react.useState)(false), showBookNowTopMobile = ref8[0], setShowBookNowTopMobile = ref8[1];
    (0,react.useEffect)(function() {
        if (!container) return;
        // Pastikan window tersedia (client-side only)
        if (false) {}
        headerClass();
        window.onscroll = function() {
            headerClass();
        };
        if (!getHeight) return;
        if (headerContainer && headerContainer.current && headerContainer.current.offsetHeight) {
            getHeight(headerContainer.current.offsetHeight);
        } else {
            getHeight(0);
        }
    }, [
        isReady
    ]);
    var headerClass = function() {
        // Pastikan window tersedia (client-side only)
        if (false) {}
        if (isDining) {
            if (window.scrollY > 162) {
                setOffsetBookNow(true);
                setOffsetHeader(true);
            } else {
                setOffsetBookNow(false);
                setOffsetHeader(false);
            }
        } else {
            if (window.scrollY > 162) {
                setOffsetHeader(true);
            } else {
                setOffsetHeader(false);
            }
            if (window.scrollY > Math.round(window.innerHeight) * 0.8) {
                setOffsetBookNow(true);
            } else {
                setOffsetBookNow(false);
            }
        }
    };
    var normalizedSecondary = typeof color_secondary === "string" ? color_secondary.trim().toLowerCase() : "";
    var isSecondaryWhite = normalizedSecondary === "white" || normalizedSecondary === "#fff" || normalizedSecondary === "#ffffff" || normalizedSecondary === "rgb(255,255,255)" || normalizedSecondary === "rgb(255, 255, 255)";
    var bookNowBg = offsetHeader ? color_primary : color_secondary;
    var bookNowTextColor = offsetHeader ? "white" : isSecondaryWhite ? color_primary : "white";
    var bookNowBorderColor = offsetHeader ? color_primary : isSecondaryWhite ? color_primary : color_secondary;
    var popUpBackground = (0,hooks/* usePopUpBackground */.Ko)({
        _ID: id1 ? id1 : 1
    }).popUpBackground;
    //search
    var ref9 = (0,react.useState)(""), serachValue = ref9[0], setSearchValue = ref9[1];
    var handleSearch = function(event) {
        if (event.key === "Enter") {
            push("/search?keyword=".concat(serachValue));
        }
    };
    var bookNowTopRef = (0,react.useRef)(null);
    (0,dist/* useOutsideClick */.O3d)({
        ref: bookNowTopRef,
        handler: function() {
            return setShowBookNowTop(false);
        }
    });
    var bookNowTopMobileRef = (0,react.useRef)(null);
    (0,dist/* useOutsideClick */.O3d)({
        ref: bookNowTopMobileRef,
        handler: function() {
            return setShowBookNowTopMobile(false);
        }
    });
    if (isNavPop1) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                    h: "143px",
                    bg: "black"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Box */.xuv, {
                    position: "fixed",
                    top: 0,
                    h: "100vh",
                    w: "100%",
                    bg: "black",
                    opacity: 0.9,
                    color: "white",
                    zIndex: 9999,
                    transition: "all .5s ease-in-out",
                    // bgImage={
                    //   popUpBackground
                    //     ? `linear-gradient(0deg, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.9)), url(${popUpBackground})`
                    //     : `linear-gradient(0deg, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.9)))`
                    // }
                    bgSize: "cover",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeFlex, {
                            zIndex: 1000,
                            position: "relative",
                            top: 0,
                            w: "100%",
                            justify: "space-between",
                            align: "flex-start",
                            px: mediaQuery/* safeMarginX */.Mp,
                            pt: 6,
                            fontSize: "x-small",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Box */.xuv, {
                                    display: {
                                        base: "none",
                                        md: "flex"
                                    },
                                    flex: 1,
                                    justifyContent: "flex-start",
                                    flexDir: "column",
                                    gap: 2,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeFlex, {
                                            alignItems: "center",
                                            gap: 2,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoLocationOutline */.kXE, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeText, {
                                                    children: location
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeFlex, {
                                            alignItems: "center",
                                            gap: 2,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCallOutline */.Ty1, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeText, {
                                                    children: phone
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Center */.M5Y, {
                                    flex: 1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                        position: "relative",
                                        h: {
                                            base: "35px",
                                            lg: "55px"
                                        },
                                        w: "100%",
                                        maxW: {
                                            base: "100px",
                                            lg: "160px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            onClick: function() {
                                                push(is_parador ? "/" : "/".concat(slug1));
                                            },
                                            style: {
                                                cursor: "pointer"
                                            },
                                            src: (0,functions/* convertImgHttps */.Nu)(logo_light),
                                            layout: "fill",
                                            objectFit: "contain",
                                            alt: "".concat(name1, " logo"),
                                            priority: true,
                                            unoptimized: true
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                    flex: 1,
                                    display: {
                                        base: "none",
                                        md: "flex"
                                    },
                                    justifyContent: "flex-end",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeFlex, {
                                        alignItems: "center",
                                        justifyContent: "flex-end",
                                        gap: 4,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeFlex, {
                                                alignItems: "center",
                                                gap: 1,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                                    mr: -1,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginSelect, {
                                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoPersonOutline */.FJ3, {
                                                            size: 16
                                                        }),
                                                        items: [
                                                            {
                                                                name: "Individual",
                                                                value: "en"
                                                            },
                                                            {
                                                                name: "Company",
                                                                value: "id"
                                                            }, 
                                                        ],
                                                        placeHolder: locale == "id" ? "Masuk" : "Log In"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Center */.M5Y, {
                                                height: "16px",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeDivider, {
                                                    borderColor: isHomepage ? "whiteAlpha.700" : "blackAlpha.700",
                                                    orientation: "vertical"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                                mr: -1,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputSelect, {
                                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoGlobeOutline */.$RS, {
                                                        size: 18
                                                    }),
                                                    items: [
                                                        {
                                                            name: "English",
                                                            value: "en"
                                                        },
                                                        {
                                                            name: "Bahasa",
                                                            value: "id"
                                                        }, 
                                                    ],
                                                    placeHolder: locale == "id" ? "Bahasa" : "English"
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderPop, {
                            hotelBrands: hotelBrands,
                            hotelCode: hotel_code,
                            setNavPop: function(isNavPop) {
                                return setIsNavPop(isNavPop);
                            },
                            navPosition: navPosition1,
                            setNavPosition: function(navPosition) {
                                return setNavPosition(navPosition);
                            },
                            slug: is_parador ? "" : slug1
                        })
                    ]
                })
            ]
        });
    }
    if (isMobilePop) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Slide */.Mi4, {
                direction: "left",
                in: isMobilePop,
                style: {
                    zIndex: 9999
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeFlex, {
                    h: "100vh",
                    w: "full",
                    bg: color_primary,
                    color: color_secondary !== null && color_secondary !== void 0 ? color_secondary : "white",
                    // opacity={0.9}
                    flexDir: "column",
                    p: mediaQuery/* safeMarginX */.Mp,
                    overflow: "scroll",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeFlex, {
                            justify: "space-between",
                            px: 4,
                            children: [
                                is_parador ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeInputGroup, {
                                    display: "flex",
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icons_esm/* SearchIcon */.W1, {
                                            fontSize: "2xl",
                                            color: "inherit"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeInput, {
                                            onChange: function(e) {
                                                return setSearchValue(e.target.value);
                                            },
                                            onKeyDown: handleSearch,
                                            variant: "filled",
                                            bg: "transparent",
                                            color: "inherit",
                                            type: "text",
                                            placeholder: locale === "id" ? "CARI" : "SEARCH",
                                            borderRadius: 0,
                                            _focus: {
                                                borderRadius: 0
                                            },
                                            _hover: {},
                                            mx: 2,
                                            pl: 2
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                    onClick: function() {
                                        return setIsMobilePop(false);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoClose */.bjh, {
                                        size: 40
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeFlex, {
                            flexDir: "column",
                            gap: 2,
                            textTransform: "uppercase",
                            mt: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeAccordion, {
                                allowToggle: true,
                                _focus: {},
                                allowMultiple: false,
                                className: "accordion-uppercase mobile-accordion",
                                children: [
                                    is_parador && /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeAccordionItem, {
                                        _focus: {},
                                        py: 2,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeAccordionButton, {
                                                    _focus: {},
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            children: locale === "id" ? "Hotel" : "Hotels"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeAccordionIcon, {})
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeAccordionPanel, {
                                                pb: 4,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeFlex, {
                                                    flexWrap: "wrap",
                                                    gap: 3,
                                                    fontSize: "sm",
                                                    flexDir: "column",
                                                    color: "whiteAlpha.700",
                                                    children: hotelMobileList.list.map(function(item, i) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTo/* default */.Z, {
                                                                to: "/".concat(hotelMobileList.target[i]),
                                                                children: item
                                                            })
                                                        }, i);
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    !is_parador && /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeAccordionItem, {
                                        _focus: {},
                                        py: 2,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeAccordionButton, {
                                            _focus: {},
                                            onClick: function() {
                                                return push("/".concat(slug1, "/rooms"));
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: locale === "id" ? "Kamar" : "Rooms"
                                            })
                                        })
                                    }),
                                    is_parador && /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeAccordionItem, {
                                        _focus: {},
                                        py: 2,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeAccordionButton, {
                                            _focus: {},
                                            onClick: function() {
                                                return push("/special-offers");
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: locale === "id" ? "Promo Spesial" : "Special Offers"
                                            })
                                        })
                                    }),
                                    !is_parador && /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeAccordionItem, {
                                        _focus: {},
                                        py: 2,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeAccordionButton, {
                                            _focus: {},
                                            onClick: function() {
                                                return push("/".concat(slug1, "/hotel-offers"));
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: locale === "id" ? "Promo" : "Offers"
                                            })
                                        })
                                    }),
                                    is_parador && /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeAccordionItem, {
                                        _focus: {},
                                        py: 2,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeAccordionButton, {
                                                    _focus: {},
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                            children: [
                                                                " ",
                                                                locale === "id" ? "Restoran" : "Dining"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeAccordionIcon, {})
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeAccordionPanel, {
                                                pb: 4,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeFlex, {
                                                    flexWrap: "wrap",
                                                    gap: 3,
                                                    fontSize: "sm",
                                                    flexDir: "column",
                                                    color: "whiteAlpha.700",
                                                    children: diningMobileListV2.map(function(param2) {
                                                        var hotel = param2.hotel, dining = param2.dining, slug = param2.slug;
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTo/* default */.Z, {
                                                                        to: "/".concat(slug, "/dining"),
                                                                        children: hotel
                                                                    })
                                                                }),
                                                                dining.map(function(param) {
                                                                    var id = param.id, name = param.name;
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                                                        ml: 4,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTo/* default */.Z, {
                                                                            to: "/dining/".concat(id),
                                                                            children: name
                                                                        })
                                                                    }, id);
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeFlex, {
                                                                    w: "100%",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeDivider, {
                                                                        orientation: "horizontal",
                                                                        opacity: 0.2
                                                                    })
                                                                })
                                                            ]
                                                        }, hotel);
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    !is_parador && has_dining === "true" && /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeAccordionItem, {
                                        _focus: {},
                                        py: 2,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeAccordionButton, {
                                            _focus: {},
                                            onClick: function() {
                                                return push("/".concat(slug1, "/dining"));
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                children: [
                                                    " ",
                                                    locale === "id" ? "Restoran" : "Dining"
                                                ]
                                            })
                                        })
                                    }),
                                    (is_parador || has_meeting_events === "true") && /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeAccordionItem, {
                                        _focus: {},
                                        py: 2,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeAccordionButton, {
                                            _focus: {},
                                            onClick: function() {
                                                return push(is_parador ? "/meeting-events" : "/".concat(slug1, "/meeting-events"));
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: locale === "id" ? "Rapat & Acara" : "Meeting & Events"
                                            })
                                        })
                                    }),
                                    !is_parador && /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeAccordionItem, {
                                        _focus: {},
                                        py: 2,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeAccordionButton, {
                                            _focus: {},
                                            onClick: function() {
                                                return push("/".concat(slug1, "/facilities"));
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: locale === "id" ? "Fasilitas" : "Facilities"
                                            })
                                        })
                                    }),
                                    (is_parador || has_wedding === "true") && /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeAccordionItem, {
                                        _focus: {},
                                        py: 2,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeAccordionButton, {
                                            _focus: {},
                                            onClick: function() {
                                                return push(is_parador ? "/wedding" : "/".concat(slug1, "/wedding"));
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: locale === "id" ? "Pernikahan" : "Wedding"
                                            })
                                        })
                                    }),
                                    is_parador && /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeAccordionItem, {
                                        _focus: {},
                                        py: 2,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeAccordionButton, {
                                            _focus: {},
                                            onClick: function() {
                                                return push(is_parador ? "/gallery" : "/".concat(slug1, "/gallery"));
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                children: [
                                                    " ",
                                                    locale === "id" ? "Galeri" : "gallery"
                                                ]
                                            })
                                        })
                                    }),
                                    !is_parador && /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeAccordionItem, {
                                        _focus: {},
                                        py: 2,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeAccordionButton, {
                                            _focus: {},
                                            onClick: function() {
                                                return push("/".concat(slug1, "/local-area"));
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: locale === "id" ? "Area Lokal" : "Local Area"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeAccordionItem, {
                                        _focus: {},
                                        py: 2,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeAccordionButton, {
                                            _focus: {},
                                            onClick: function() {
                                                return push(is_parador ? "/contact" : "/".concat(slug1, "/contact"));
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: locale === "id" ? "Kontak" : "Contact Us"
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Box */.xuv, {
        display: "initial",
        position: "relative",
        top: 0,
        color: isHomepage ? color_secondary : color_primary,
        ref: headerContainer,
        className: !isHomepage ? "header-box-shadows" : "",
        children: [
            is2XLarge ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeFlex, {
                bg: isHomepage ? color_primary : "white",
                color: isHomepage ? "white" : "blackAlpha.900",
                zIndex: 1000,
                position: "relative",
                top: 0,
                w: "100%",
                justify: "space-between",
                align: "flex-start",
                px: mediaQuery/* safeMarginX */.Mp,
                pt: 6,
                fontSize: "x-small",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Box */.xuv, {
                        display: {
                            base: "none",
                            md: "flex"
                        },
                        flex: 1,
                        justifyContent: "flex-start",
                        flexDir: "column",
                        gap: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                w: "max-content",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeFlex, {
                                    alignItems: "center",
                                    gap: 2,
                                    cursor: "pointer",
                                    onClick: function() {
                                        return window.open(location_url, "_blank");
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoLocationOutline */.kXE, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeText, {
                                            children: location
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                w: "max-content",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeFlex, {
                                    alignItems: "center",
                                    gap: 2,
                                    cursor: "pointer",
                                    onClick: function() {
                                        return window.open("tel:".concat(phone));
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCallOutline */.Ty1, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeText, {
                                            children: phone
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Center */.M5Y, {
                        flex: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                            position: "relative",
                            h: {
                                base: "35px",
                                lg: "55px"
                            },
                            w: "100%",
                            maxW: "160px",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                onClick: function() {
                                    push(is_parador ? "/" : "/".concat(slug1));
                                },
                                style: {
                                    cursor: "pointer"
                                },
                                src: isHomepage ? (0,functions/* convertImgHttps */.Nu)(logo_light) : (0,functions/* convertImgHttps */.Nu)(logo_dark),
                                layout: "fill",
                                objectFit: "contain",
                                alt: "".concat(name1, " logo"),
                                priority: true,
                                unoptimized: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                        flex: 1,
                        display: {
                            base: "none",
                            md: "flex"
                        },
                        justifyContent: "flex-end",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeFlex, {
                            alignItems: "center",
                            justifyContent: "flex-end",
                            gap: 4,
                            children: [
                                !is_parador && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeFlex, {
                                            alignItems: "center",
                                            gap: 1,
                                            cursor: "pointer",
                                            onClick: function() {
                                                push("/");
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoChevronBackCircleOutline */.diU, {
                                                    style: {
                                                        marginBottom: 1
                                                    },
                                                    size: 15
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeText, {
                                                    children: "Parador"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Center */.M5Y, {
                                            height: "16px",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeDivider, {
                                                borderColor: isHomepage ? "whiteAlpha.700" : "blackAlpha.700",
                                                orientation: "vertical"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeFlex, {
                                    alignItems: "center",
                                    gap: 1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                        mr: -1,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginSelect, {
                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoPersonOutline */.FJ3, {
                                                size: 16
                                            }),
                                            items: [
                                                {
                                                    name: "Individual",
                                                    value: "en"
                                                },
                                                {
                                                    name: "Company",
                                                    value: "id"
                                                }, 
                                            ],
                                            placeHolder: locale == "id" ? "Masuk" : "Log In"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Center */.M5Y, {
                                    height: "16px",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeDivider, {
                                        borderColor: isHomepage ? "whiteAlpha.700" : "blackAlpha.700",
                                        orientation: "vertical"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                    mr: -1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputSelect, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoGlobeOutline */.$RS, {
                                            size: 18
                                        }),
                                        items: [
                                            {
                                                name: "English",
                                                value: "en"
                                            },
                                            {
                                                name: "Bahasa",
                                                value: "id"
                                            }, 
                                        ],
                                        placeHolder: locale == "id" ? "Bahasa" : "English"
                                    })
                                })
                            ]
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeFlex, {
                justify: "space-between",
                align: "center",
                bg: isHomepage ? color_primary : "white",
                color: isHomepage ? color_secondary !== null && color_secondary !== void 0 ? color_secondary : "white" : color_primary,
                pt: [
                    4
                ],
                px: mediaQuery/* safeMarginX */.Mp,
                zIndex: 999,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                        position: "relative",
                        w: is_parador ? "80px" : "50px",
                        h: "50px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            onClick: function() {
                                push(is_parador ? "/" : "/".concat(slug1));
                            },
                            style: {
                                cursor: "pointer"
                            },
                            src: isHomepage ? (0,functions/* convertImgHttps */.Nu)(logo_light) : (0,functions/* convertImgHttps */.Nu)(logo_dark),
                            layout: "fill",
                            objectFit: "contain",
                            alt: "".concat(name1, " logo"),
                            priority: true,
                            unoptimized: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeFlex, {
                        align: "center",
                        gap: 4,
                        children: [
                            !is_parador && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                        onClick: function() {
                                            return push("/");
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoChevronBackCircleOutline */.diU, {
                                            size: 20
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Center */.M5Y, {
                                        height: "20px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeDivider, {
                                            orientation: "vertical",
                                            borderColor: "inherit",
                                            opacity: 1
                                        })
                                    })
                                ]
                            }),
                             false && /*#__PURE__*/ 0,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeSelect, {
                                border: "none",
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                _focus: {},
                                className: "reset-select-mobile",
                                onChange: function(e) {
                                    return push({
                                        pathname: pathname,
                                        query: query
                                    }, asPath, {
                                        locale: e.target.value
                                    });
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        selected: locale == "en",
                                        value: "en",
                                        children: "ENG"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        selected: locale == "id",
                                        value: "id",
                                        children: "BHS"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeFlex, {
                // bg={offsetHeader || !isHomepage ? `white` : color_primary}
                // bg="red"
                bg: offsetHeader || !isHomepage ? "white" : color_primary,
                color: offsetHeader || !isHomepage ? color_primary : "white",
                zIndex: 999,
                position: "sticky",
                top: 0,
                w: "100%",
                px: mediaQuery/* safeMarginX */.Mp,
                py: 3,
                justify: "space-between",
                align: "flex-start",
                className: "nav-container ".concat(offsetHeader || !isHomepage && is2XLarge ? "header-box-shadows" : ""),
                children: is2XLarge ? /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeFlex, {
                    flexDir: "column",
                    w: "100%",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeFlex, {
                        alignItems: "center",
                        w: "100%",
                        color: "inherit",
                        pb: navPosition1 == "store" ? 14 : 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                    flex: 1,
                                    w: "100%",
                                    children: is_parador ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeInputGroup, {
                                        display: "flex",
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icons_esm/* SearchIcon */.W1, {
                                                fontSize: "xl",
                                                color: "inherit"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeInput, {
                                                onChange: function(e) {
                                                    return setSearchValue(e.target.value);
                                                },
                                                onKeyDown: handleSearch,
                                                variant: "filled",
                                                bg: "transparent",
                                                color: "inherit",
                                                type: "text",
                                                placeholder: locale === "id" ? "CARI" : "SEARCH",
                                                borderRadius: 0,
                                                _focus: {
                                                    borderRadius: 0
                                                },
                                                _hover: {},
                                                mx: 2,
                                                pl: 2
                                            })
                                        ]
                                    }) : offsetHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeFlex, {
                                        justify: "flex-start",
                                        position: "relative",
                                        h: "40px",
                                        w: "50px",
                                        cursor: "pointer",
                                        onClick: function() {
                                            return push("/".concat(slug1));
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: logo_light,
                                            alt: "logo",
                                            layout: "fill",
                                            objectFit: "contain",
                                            priority: true,
                                            unoptimized: true
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeFlex, {
                                    flex: 5,
                                    mx: is_parador ? 6 : 0,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeFlex, {
                                        color: "inherit",
                                        gap: is_parador ? 10 : 6,
                                        fontSize: "sm",
                                        fontWeight: 500,
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        w: "100%",
                                        h: "40px",
                                        textTransform: "uppercase",
                                        wordBreak: "keep-all",
                                        whiteSpace: "nowrap",
                                        children: [
                                            is_parador ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkTo/* default */.Z, {
                                                activeColor: handleActiveColor,
                                                onClick: function(e) {
                                                    setNavPosition("hotels");
                                                    setIsNavPop(true);
                                                    e.preventDefault();
                                                },
                                                className: "link-with-icon",
                                                children: [
                                                    locale === "id" ? "Hotel" : "Hotels",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoChevronDown */.CgR, {
                                                        color: handleActiveColor().toString().replace("#", "%23")
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTo/* default */.Z, {
                                                active: navPosition1.includes("rooms"),
                                                activeColor: handleActiveColor,
                                                to: "/".concat(slug1, "/rooms"),
                                                children: locale === "id" ? "Kamar" : "Rooms"
                                            }),
                                            is_parador ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTo/* default */.Z, {
                                                active: navPosition1.includes("special-offer"),
                                                activeColor: handleActiveColor,
                                                to: "/special-offers",
                                                children: locale === "id" ? "Promo Spesial" : "Special Offers"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTo/* default */.Z, {
                                                active: navPosition1.includes("hotel-offer"),
                                                activeColor: handleActiveColor,
                                                to: "/".concat(slug1, "/hotel-offers"),
                                                children: locale === "id" ? "Promo" : "Offers"
                                            }),
                                            (has_dining === "true" || is_parador) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkTo/* default */.Z, {
                                                activeColor: handleActiveColor,
                                                active: !is_parador && navPosition1.includes("dining"),
                                                onClick: function(e) {
                                                    setNavPosition("dining");
                                                    is_parador ? setIsNavPop(true) : push("/".concat(slug1, "/dining"));
                                                    e.preventDefault();
                                                },
                                                className: "link-with-icon",
                                                to: !is_parador ? "/".concat(slug1, "/dining") : "#",
                                                children: [
                                                    locale === "id" ? "Restoran" : "Dining",
                                                    is_parador && /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoChevronDown */.CgR, {
                                                        color: handleActiveColor().toString().replace("#", "%23")
                                                    })
                                                ]
                                            }),
                                            has_meeting_events === "true" && /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTo/* default */.Z, {
                                                active: navPosition1.includes("meeting-events"),
                                                activeColor: handleActiveColor,
                                                to: is_parador ? "/meeting-events" : "/".concat(slug1, "/meeting-events"),
                                                children: locale === "id" ? "Rapat & Acara" : "Meeting & Events"
                                            }),
                                            !is_parador && /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTo/* default */.Z, {
                                                active: navPosition1.includes("facilities"),
                                                activeColor: handleActiveColor,
                                                to: "/".concat(slug1, "/facilities"),
                                                children: locale === "id" ? "Fasilitas" : "Facilities"
                                            }),
                                            has_wedding === "true" && /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTo/* default */.Z, {
                                                active: navPosition1.includes("wedding"),
                                                activeColor: handleActiveColor,
                                                to: is_parador ? "/wedding" : "/".concat(slug1, "/wedding"),
                                                children: locale === "id" ? "Pernikahan" : "Wedding"
                                            }),
                                            !is_parador && /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTo/* default */.Z, {
                                                active: navPosition1.includes("gallery"),
                                                activeColor: isHomepage && !offsetHeader ? "white" : color_primary,
                                                to: "/".concat(slug1, "/gallery"),
                                                children: locale === "id" ? "Galeri" : "gallery"
                                            }),
                                            !is_parador && /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTo/* default */.Z, {
                                                active: navPosition1.includes("local-area"),
                                                activeColor: handleActiveColor,
                                                to: "/".concat(slug1, "/local-area"),
                                                children: locale === "id" ? "Area Lokal" : "Local Area"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTo/* default */.Z, {
                                                active: navPosition1.includes("contact"),
                                                activeColor: handleActiveColor,
                                                to: is_parador ? "/contact" : "/".concat(slug1, "/contact"),
                                                children: locale === "id" ? "Kontak" : "Contact Us"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeFlex, {
                                    flex: 1,
                                    justify: "flex-end",
                                    position: "relative",
                                    ref: bookNowTopRef,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeButton, {
                                            onClick: handleBook,
                                            bg: bookNowBg,
                                            color: bookNowTextColor,
                                            borderWidth: 1,
                                            borderColor: bookNowBorderColor,
                                            _hover: {
                                                bg: color_primary,
                                                color: "white",
                                                border: "1px solid ".concat(color_primary)
                                            },
                                            children: locale === "id" ? "Pesan" : "Book Now"
                                        }),
                                        showBookNowTop && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                            position: "absolute",
                                            right: 0,
                                            top: 16,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormBookNowTop/* default */.Z, {
                                                hotelCode: hotel_code,
                                                colorPrimary: color_primary
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeFlex, {
                    justify: "space-between",
                    align: "center",
                    w: "100%",
                    position: "relative",
                    ref: bookNowTopMobileRef,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                            onClick: function() {
                                return setIsMobilePop(true);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaGripLines */.U9V, {
                                size: 32,
                                color: handleActiveColor().toString()
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeButton, {
                            h: "100%",
                            onClick: function() {
                                setShowBookNowTopMobile(!showBookNowTopMobile);
                            },
                            bg: bookNowBg,
                            color: bookNowTextColor,
                            borderWidth: 1,
                            borderColor: bookNowBorderColor,
                            _hover: {},
                            children: locale === "id" ? "Pesan" : "Book Now"
                        }),
                        showBookNowTopMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                            position: "absolute",
                            right: 0,
                            top: 14,
                            zIndex: 10000,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Center */.M5Y, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormBookNowTop/* default */.Z, {
                                    hotelCode: hotel_code,
                                    colorPrimary: color_primary
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var FilterOptions = [
    {
        value: "brands",
        label: "Brands"
    },
    {
        value: "location",
        label: "Location"
    }, 
];
var hotelLoc = [
    "atria-hotel-gading-serpong",
    "atria-residences-gading-serpong",
    "vega-hotel-gading-serpong",
    "fame-hotel-gading-serpong",
    "starlet-hotel-serpong",
    "starlet-hotel-bsd-city",
    "fame-hotel-sunset-road",
    "starlet-hotel-jakarta-airport",
    "atria-hotel-magelang",
    "atria-hotel-malang", 
];
function HeaderPop(param) {
    var hotelBrands = param.hotelBrands, hotelCode = param.hotelCode, setNavPop = param.setNavPop, navPosition = param.navPosition, setNavPosition = param.setNavPosition, slug = param.slug, idHotel = param.idHotel;
    var handleBook = function handleBook() {
        setShowBookNowTop(!showBookNowTop);
    };
    var ref = (0,next_router.useRouter)(), route = ref.route, push = ref.push, locale = ref.locale, pathname = ref.pathname, query = ref.query, asPath = ref.asPath;
    var ref10 = (0,hooks/* useNextDining */.fI)(), listDining = ref10.listDining, isLoading = ref10.isLoading, isError = ref10.isError;
    var ref11 = (0,react.useState)("brands"), filterOption = ref11[0], setFilterOption = ref11[1];
    var ref12 = (0,react.useState)(""), serachValue = ref12[0], setSearchValue = ref12[1];
    var handleSearch = function(event) {
        if (event.key === "Enter") {
            push("/search?keyword=".concat(serachValue));
        }
    };
    var ref13 = (0,react.useState)(false), showBookNowTop = ref13[0], setShowBookNowTop = ref13[1];
    var bookNowTopRef = (0,react.useRef)(null);
    (0,dist/* useOutsideClick */.O3d)({
        ref: bookNowTopRef,
        handler: function() {
            return setShowBookNowTop(false);
        }
    });
    var headerPopView = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeFlex, {
                alignItems: "center",
                w: "100%",
                color: "inherit",
                px: mediaQuery/* safeMarginX */.Mp,
                py: 3,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                            flex: 1,
                            w: "100%",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeInputGroup, {
                                display: "flex",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icons_esm/* SearchIcon */.W1, {
                                        fontSize: "xl",
                                        color: "inherit"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeInput, {
                                        onChange: function(e) {
                                            return setSearchValue(e.target.value);
                                        },
                                        onKeyDown: handleSearch,
                                        variant: "filled",
                                        bg: "transparent",
                                        color: "inherit",
                                        type: "text",
                                        placeholder: locale === "id" ? "CARI" : "SEARCH",
                                        borderRadius: 0,
                                        _focus: {
                                            borderRadius: 0
                                        },
                                        _hover: {},
                                        mx: 2,
                                        pl: 2
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeFlex, {
                            flex: 5,
                            mx: 6,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeFlex, {
                                color: "inherit",
                                gap: 10,
                                fontSize: "sm",
                                fontWeight: 500,
                                justifyContent: "space-between",
                                alignItems: "center",
                                w: "100%",
                                textTransform: "uppercase",
                                wordBreak: "keep-all",
                                whiteSpace: "nowrap",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkTo/* default */.Z, {
                                        activeColor: "white",
                                        active: navPosition == "hotels",
                                        onClick: function(e) {
                                            setNavPosition(navPosition == "hotels" ? asPath : "hotels");
                                            setNavPop(navPosition == "hotels" ? false : true);
                                            e.preventDefault();
                                        },
                                        className: "link-with-icon",
                                        children: [
                                            locale === "id" ? "Hotel" : "Hotels",
                                            navPosition == "hotels" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoChevronUp */.AZg, {
                                                color: "white"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoChevronDown */.CgR, {
                                                color: "white"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTo/* default */.Z, {
                                        activeColor: "white",
                                        to: "/special-offers",
                                        children: locale === "id" ? "Promo Spesial" : "Special Offers"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkTo/* default */.Z, {
                                        activeColor: "white",
                                        active: navPosition == "dining",
                                        onClick: function(e) {
                                            setNavPosition(navPosition == "dining" ? asPath : "dining");
                                            setNavPop(navPosition == "dining" ? false : true);
                                            e.preventDefault();
                                        },
                                        className: "link-with-icon",
                                        to: "#",
                                        children: [
                                            locale === "id" ? "Restoran" : "Dining",
                                            navPosition == "dining" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoChevronUp */.AZg, {
                                                color: "white"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoChevronDown */.CgR, {
                                                color: "white"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTo/* default */.Z, {
                                        activeColor: "white",
                                        // to={`/${slug}/hotel-offers`}
                                        to: "/meeting-events",
                                        children: locale === "id" ? "Rapat & Acara" : "Meeting & Events"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTo/* default */.Z, {
                                        activeColor: "white",
                                        to: "/wedding",
                                        children: locale === "id" ? "Pernikahan" : "Wedding"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTo/* default */.Z, {
                                        activeColor: "white",
                                        to: "/contact",
                                        children: locale === "id" ? "Kontak" : "Contact Us"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeFlex, {
                            flex: 1,
                            justify: "flex-end",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Box */.xuv, {
                                    position: "relative",
                                    ref: bookNowTopRef,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeButton, {
                                            onClick: handleBook,
                                            bg: "white",
                                            color: "black",
                                            borderWidth: 1,
                                            borderColor: "black",
                                            _hover: {},
                                            children: locale === "id" ? "Pesan" : "Book Now"
                                        }),
                                        showBookNowTop && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                            position: "absolute",
                                            right: 0,
                                            top: 16,
                                            zIndex: 10000,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormBookNowTop/* default */.Z, {
                                                hotelCode: hotelCode,
                                                colorPrimary: "black"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                    position: "absolute",
                                    mt: 1,
                                    right: "3%",
                                    cursor: "pointer",
                                    onClick: function() {
                                        return setNavPop(false);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoClose */.bjh, {
                                        size: 24
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            navPosition === "hotels" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeFlex, {
                justify: "flex-end",
                px: mediaQuery/* safeMarginX */.Mp,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                    mr: -3,
                    className: "custom-select",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeSelect, {
                        border: 0,
                        fontSize: "xs",
                        _focus: {},
                        cursor: "pointer",
                        textTransform: "uppercase",
                        color: "white",
                        value: filterOption ? filterOption : undefined,
                        onChange: function(e) {
                            setFilterOption(e.target.value);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                value: "brands",
                                children: locale == "id" ? "MEREK" : "BRANDS"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                value: "location",
                                children: locale == "id" ? "LOKASI" : "LOCATION"
                            })
                        ]
                    })
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                h: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeFlex, {
                px: mediaQuery/* safeMarginX */.Mp,
                color: "white",
                gap: 10,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Box */.xuv, {
                        w: "20%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeHeading, {
                                as: "h1",
                                fontSize: "xl",
                                letterSpacing: 2,
                                fontWeight: 400,
                                mb: 4,
                                mr: 4,
                                wordBreak: "break-word",
                                whiteSpace: "pre-wrap",
                                children: [
                                    navPosition === "hotels" && (locale == "id" ? "EKOSISTEM HOTEL YANG HOLISTIK\n" : "A HOLISTIC ECOSYSTEM OF HOTELS"),
                                    navPosition === "dining" && (locale == "id" ? "MASAKAN PENUH PETUALANGAN\n" : "AN ADVENTUROUS CUISINE")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeText, {
                                fontSize: "sm",
                                mr: 4,
                                color: "whiteAlpha.900",
                                children: [
                                    navPosition === "hotels" && (locale == "id" ? "Meningkatkan cara Hidup, Bekerja, Bermain, dan Berbisnis; melalui pengalaman menginap dan bersantap tanpa batas." : "Elevating live, work, play, and do business; through limitless experiences in staying and dining."),
                                    navPosition === "dining" && (locale == "id" ? "Jelajahi pengalaman menikmati makanan bercita rasa tinggi yang etis, terkini, dan penuh perhatian dalam penyajian." : "Explore into an exquisite sensory feast of ethical eating, conscious cuisine, and cutting edge eat experience.\n")
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Center */.M5Y, {
                            height: "100%",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeDivider, {
                                orientation: "vertical"
                            })
                        })
                    }),
                    navPosition === "hotels" && filterOption === "brands" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeFlex, {
                        gap: 12,
                        textTransform: "uppercase",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeFlex, {
                                direction: "column",
                                gap: 5,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelList, {
                                        name: hotelBrands[0].name,
                                        list: hotelBrands[0].list,
                                        linkTo: hotelBrands[0].linkTo
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeDivider, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelList, {
                                        name: hotelBrands[1].name,
                                        list: hotelBrands[1].list,
                                        linkTo: hotelBrands[1].linkTo
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeFlex, {
                                direction: "column",
                                gap: 5,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelList, {
                                        name: hotelBrands[2].name,
                                        list: hotelBrands[2].list,
                                        linkTo: hotelBrands[2].linkTo
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeDivider, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelList, {
                                        name: hotelBrands[3].name,
                                        list: hotelBrands[3].list,
                                        linkTo: hotelBrands[3].linkTo
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeFlex, {
                                direction: "column",
                                gap: 5,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelList, {
                                    name: hotelBrands[4].name,
                                    list: hotelBrands[4].list,
                                    linkTo: hotelBrands[4].linkTo
                                })
                            })
                        ]
                    }),
                    navPosition === "hotels" && filterOption === "location" && (isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Center */.M5Y, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeSpinner, {
                            size: "xl",
                            color: "white"
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeFlex, {
                        gap: 16,
                        textTransform: "uppercase",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeFlex, {
                                direction: "column",
                                gap: 5,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelList, {
                                    name: "Tangerang",
                                    nameLink: "/filter?type=hotel&location=tangerang",
                                    setNavPop: function(isNavPop) {
                                        return setNavPop(isNavPop);
                                    },
                                    list: [
                                        "ATRIA HOTEL",
                                        "ATRIA RESIDENCES",
                                        "VEGA HOTEL",
                                        "FAME HOTEL",
                                        "STARLET HOTEL",
                                        "STARLET HOTEL", 
                                    ],
                                    sublist: [
                                        "GADING serpong",
                                        "GADING serpong",
                                        "GADING serpong",
                                        "GADING serpong",
                                        "serpong",
                                        "BSD CITY", 
                                    ],
                                    linkTo: [
                                        hotelLoc[0],
                                        hotelLoc[1],
                                        hotelLoc[2],
                                        hotelLoc[3],
                                        hotelLoc[4],
                                        hotelLoc[5], 
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeFlex, {
                                direction: "column",
                                gap: 5,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelList, {
                                        name: "BALI",
                                        nameLink: "/filter?type=hotel&location=bali",
                                        list: [
                                            "FAME HOTEL"
                                        ],
                                        sublist: [
                                            "SUNSET ROAD"
                                        ],
                                        linkTo: [
                                            hotelLoc[6]
                                        ],
                                        setNavPop: function(isNavPop) {
                                            return setNavPop(isNavPop);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeDivider, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelList, {
                                        name: "JAKARTA",
                                        nameLink: "/filter?type=hotel&location=jakarta",
                                        list: [
                                            "STARLET HOTEL"
                                        ],
                                        sublist: [
                                            "JAKARTA AIRPORT"
                                        ],
                                        linkTo: [
                                            hotelLoc[7]
                                        ],
                                        setNavPop: function(isNavPop) {
                                            return setNavPop(isNavPop);
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeFlex, {
                                direction: "column",
                                gap: 5,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelList, {
                                        name: "Magelang",
                                        nameLink: "/filter?type=hotel&location=magelang",
                                        list: [
                                            "ATRIA HOTEL"
                                        ],
                                        sublist: [
                                            "MAGELANG"
                                        ],
                                        linkTo: [
                                            hotelLoc[8]
                                        ],
                                        setNavPop: function(isNavPop) {
                                            return setNavPop(isNavPop);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeDivider, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelList, {
                                        name: "Malang",
                                        nameLink: "/filter?type=hotel&location=malang",
                                        list: [
                                            "ATRIA HOTEL"
                                        ],
                                        sublist: [
                                            "MALANG"
                                        ],
                                        linkTo: [
                                            hotelLoc[9]
                                        ],
                                        setNavPop: function(isNavPop) {
                                            return setNavPop(isNavPop);
                                        }
                                    })
                                ]
                            })
                        ]
                    })),
                    navPosition === "dining" && (isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Center */.M5Y, {
                        flex: 1,
                        mt: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeSpinner, {
                            size: "xl",
                            color: "white"
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeFlex, {
                        gap: 16,
                        textTransform: "uppercase",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeFlex, {
                                direction: "column",
                                gap: 5,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelList, {
                                    name: listDining[0].name,
                                    nameLink: "/filter?type=dining&location=tangerang",
                                    list: listDining[0].list,
                                    sublist: listDining[0].subList,
                                    linkTo: listDining[0].linkTo
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeFlex, {
                                direction: "column",
                                gap: 5,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelList, {
                                        name: listDining[1].name,
                                        nameLink: "/filter?type=dining&location=magelang",
                                        list: listDining[1].list,
                                        sublist: listDining[1].subList,
                                        linkTo: listDining[1].linkTo
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeDivider, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelList, {
                                        name: listDining[2].name,
                                        nameLink: "/filter?type=dining&location=malang",
                                        list: listDining[2].list,
                                        sublist: listDining[2].subList,
                                        linkTo: listDining[2].linkTo
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeFlex, {
                                direction: "column",
                                gap: 5,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelList, {
                                    name: listDining[3].name,
                                    nameLink: "/filter?type=dining&location=bali",
                                    list: listDining[3].list,
                                    sublist: listDining[3].subList,
                                    linkTo: listDining[3].linkTo
                                })
                            })
                        ]
                    }))
                ]
            })
        ]
    });
    return headerPopView;
}
function HotelList(param) {
    var name = param.name, list = param.list, _sublist = param.sublist, sublist = _sublist === void 0 ? [] : _sublist, _linkTo = param.linkTo, linkTo = _linkTo === void 0 ? [] : _linkTo, nameLink = param.nameLink, setNavPop = param.setNavPop;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeFlex, {
        direction: "column",
        gap: 3,
        children: [
            nameLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTo/* default */.Z, {
                activeColor: "white",
                to: nameLink,
                onClick: function() {
                    return setNavPop(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeText, {
                    fontSize: "xl",
                    letterSpacing: 3,
                    fontWeight: 400,
                    mb: 1,
                    children: name
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeText, {
                fontSize: "xl",
                letterSpacing: 3,
                fontWeight: 400,
                mb: 1,
                children: name
            }),
            list.map(function(item, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Box */.xuv, {
                    color: "whiteAlpha.700",
                    letterSpacing: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTo/* default */.Z, {
                            onClick: function() {
                                linkTo.length > 0 ? router.push("/".concat(linkTo[i])) : alert("it doesn't get you anywhere, yet.");
                            },
                            to: linkTo.length > 0 ? "/".concat(linkTo[i]) : "#",
                            fontSize: "md",
                            children: item
                        }),
                        sublist.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeText, {
                            my: 1,
                            fontSize: "x-small",
                            children: sublist[i]
                        })
                    ]
                }, i);
            })
        ]
    });
}
var hotelMobileList = {
    list: [
        "Atria Hotel Gading Serpong",
        "Atria Hotel Magelang",
        "Atria Hotel Malang",
        "Atria residences Gading Serpong",
        "Vega Hotel Gading Serpong",
        "Fame Hotel Gading Serpong",
        "Fame Hotel Sunset Road",
        // "HA-KA Hotel Semarang",
        "Starlet Hotel Jakarta Airport",
        "Starlet Hotel BSD City",
        "Starlet Hotel Serpong", 
    ],
    target: [
        "atria-hotel-gading-serpong",
        "atria-hotel-magelang",
        "atria-hotel-malang",
        "atria-residences-gading-serpong",
        "vega-hotel-gading-serpong",
        "fame-hotel-gading-serpong",
        "fame-hotel-sunset-road",
        // "haka-hotel-semarang",
        "starlet-hotel-jakarta-airport",
        "starlet-hotel-bsd-city",
        "starlet-hotel-serpong", 
    ]
};
var diningMobileList = [
    {
        id: 8,
        name: "BATEEQ LOUNGE"
    },
    {
        id: 11,
        name: "BATEEQ LOUNGE"
    },
    {
        id: 13,
        name: "BATEEQ LOUNGE"
    },
    {
        id: 14,
        name: "Bianco Sapori D'Italia"
    },
    {
        id: 12,
        name: "LEGEN RESTAURANT"
    },
    {
        id: 18,
        name: "HANGRY RESTAURANT"
    },
    {
        id: 2,
        name: "LEGEN LOUNGE & BAR"
    },
    {
        id: 20,
        name: "LEGEN RESTAURANT"
    },
    {
        id: 10,
        name: "PAMILUTO RESTAURANT"
    },
    {
        id: 16,
        name: "POPCORN RESTAURANT"
    },
    {
        id: 17,
        name: "POPCORN RESTAURANT"
    },
    {
        id: 15,
        name: "YUGO RESTAURANT"
    }, 
];
var diningMobileListV2 = [
    {
        hotel: "atria hotel gading serpong",
        slug: "atria-hotel-gading-serpong",
        dining: [
            {
                id: 8,
                name: "BATEEQ LOUNGE"
            },
            {
                id: 20,
                name: "LEGEN RESTAURANT"
            }, 
        ]
    },
    {
        hotel: "atria residences gading serpong",
        slug: "atria-residences-gading-serpong",
        dining: [
            {
                id: 14,
                name: "Bianco Sapori D'Italia"
            }
        ]
    },
    {
        hotel: "atria hotel magelang",
        slug: "atria-hotel-magelang",
        dining: [
            {
                id: 11,
                name: "BATEEQ LOUNGE"
            },
            {
                id: 10,
                name: "PAMILUTO RESTAURANT"
            }, 
        ]
    },
    {
        hotel: "atria hotel malang",
        slug: "atria-hotel-malang",
        dining: [
            {
                id: 13,
                name: "BATEEQ LOUNGE"
            },
            {
                id: 12,
                name: "LEGEN RESTAURANT"
            }, 
        ]
    },
    {
        hotel: "fame hotel gading serpong",
        slug: "fame-hotel-gading-serpong",
        dining: [
            {
                id: 17,
                name: "POPCORN RESTAURANT"
            }
        ]
    },
    {
        hotel: "fame hotel sunset road",
        slug: "fame-hotel-sunset-road",
        dining: [
            {
                id: 16,
                name: "POPCORN RESTAURANT"
            }
        ]
    },
    // {
    //   hotel: "ha-ka hotel semarang",
    //   slug: "haka-hotel-semarang",
    //   dining: [{ id: 18, name: "HANGRY RESTAURANT" }],
    // },
    {
        hotel: "vega hotel gading serpong",
        slug: "vega-hotel-gading-serpong",
        dining: [
            {
                id: 15,
                name: "YUGO RESTAURANT"
            }
        ]
    }, 
];


/***/ }),

/***/ 1914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Section; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function Section(props) {
    var variant = props.variant, rest = _objectWithoutProperties(props, [
        "variant"
    ]);
    var styles = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .useStyleConfig */ .mqc)("Section", {
        variant: variant
    });
    // Pass the computed styles into the `__css` prop
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, _objectSpread({
        as: "section",
        __css: styles
    }, rest));
};


/***/ })

}]);